import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Навигационная панель без аутентификации
const Navbar = ({ theme, onToggleTheme, onOpenAbout, onOpenSupport }) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(open => !open);
  const closeMenu = () => setMenuOpen(false);
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu}>🔐 VaultZip</Link>
        </div>
        <button
          className="burger"
          aria-label="Open menu"
          aria-expanded={menuOpen}
          aria-controls="nav-menu"
          onClick={toggleMenu}
        >
          ☰
        </button>
        <div id="nav-menu" className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link
            to="/encrypt"
            onClick={closeMenu}
            className={`nav-link ${location.pathname.startsWith('/encrypt') ? 'active' : ''}`}
          >
            🔒 Encrypt
          </Link>
          <Link
            to="/extract"
            onClick={closeMenu}
            className={`nav-link ${location.pathname.startsWith('/extract') ? 'active' : ''}`}
          >
            🔓 Extract
          </Link>
          <button className="nav-link" onClick={() => { onOpenAbout?.(); closeMenu(); }} title="About">
            ℹ️ About
          </button>
          <button className="nav-link" onClick={() => { onOpenSupport?.(); closeMenu(); }} title="Support">
            💬 Support
          </button>
          <button onClick={onToggleTheme} className="theme-toggle" title="Toggle theme">
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
